/* eslint-disable */
import { QuestionIcon } from "@chakra-ui/icons";
import {
  Flex,
  FormControl,
  FormLabel,
  Select,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface B4FSelectProps {
  options: any;
  label?: string;
  id?: string;
  onChange: any;
  onBlur?: any;
  value: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
  condition?: string;
  visible: boolean;
  t: any;
  i18n: any;
}

export const B4FSelect: React.FC<any> = (props) => {
  const [value, setValue] = useState(props.value);
  const [touched, setTouched] = useState(false);
  const [highlight, setHighlight] = useState(false);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setValue(props.value);

    if (props.isRequired) {
      if (!isValid(value)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }, [props.value]);

  function handleChange(e: any) {
    setTouched(true);
    props.onChange({
      id: props.id,
      type: "select",
      value: e.target.value,
      condition: props.condition,
      valid: isValid(e.target.value),
      required: props.isRequired,
    });
    setValue(e.target.value);
  }

  function handleBlur(e: any) {
    props.onBlur({
      id: props.id,
      type: "select",
      value: e.target.value,
      condition: props.condition,
      valid: isValid(e.target.value),
      required: props.isRequired,
    });

    if (props.isRequired) {
      if (!isValid(value)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }

  function isValid(value: string): boolean {
    if (props.isRequired && value != "" && value != null) {
      return true;
    } else {
      return false;
    }
  }

  let optionsArray = Array();

  if (props.options) {
    for (let k = 0; k < props.options.length; k++) {
      optionsArray.push(
        <option key={props.options[k].key} value={props.options[k].key}>
          {t(props.options[k].key)}
        </option>
      );
    }
  }

  if (props.visible) {
    return (
      <FormControl
        id={props.id}
        key={props.label}
        mb={2}
        isRequired={props.isRequired}
        isDisabled={props.isDisabled}
      >
        <Flex>
          <FormLabel>{t(props.label)}</FormLabel>
          {props.tooltip && props.tooltip !== "" ? (
            <Tooltip
              label={props.tooltip}
              fontSize="md"
              bg="brand.white"
              color="brand.text"
            >
              {props.isDisabled ? (
                <QuestionIcon color="brand.grey" />
              ) : (
                <QuestionIcon color="brand.bf2" />
              )}
            </Tooltip>
          ) : null}
        </Flex>
        <Select
          color="#636E95"
          placeholder={t("SELECT_OPTION")}
          bg="brand.inputBackground"
          borderWidth="1px"
          focusBorderColor="brand.bf3"
          borderColor="brand.inputBorder"
          onBlur={handleBlur}
          onChange={handleChange}
          value={value}
          errorBorderColor="brand.bf2"
          isInvalid={highlight}
        >
          {optionsArray}
        </Select>
      </FormControl>
    );
  } else {
    return null;
  }
};
